module.exports = __webpack_public_path__ + "img/8cc9bf1.svg";